<template>
    <div v-if="type == 'merchandising'" class="product-card">
        <Link :href="`/${merchandising.targetUrl}`" class="article-card promo" aria-label="Shop best sellers for your next great adventure">
            <img class="article-card__image" loading="lazy"  :src="merchandising.imageUrl" :alt="merchandising.imageAlt"/>
            <div class="article-card__content" >
                <!-- <p class="article-card__title headline-s text-rothcoWhite article-card__action text-link primary dar">{{ merchandising.title }}</p> -->
                
                <span class="article-card__action headline-s text-rothcoWhite">
                    {{merchandising.title}}
                </span>
            </div>
        </Link>
    </div>
        <!-- Product Card DTC Item Start -->
        <div class="product-card" v-else-if="!isB2B">
            <div class="product-card__image-actions desktop-hidden-flex">
                <div class="product-card__image-mark badge" v-if="productCardDetails.bestSeller || productCardDetails.badge" :id="`${slugifiedTitle}-badge`">
                    {{ productCardDetails.badge ?? 'BEST SELLER' }}
                </div>
                <div class="product-card__image-favorite">
                    <div @click="changeListStatus">
                        <BookmarkIcon v-if="favoriteFillStyle" alt="favorite-icon"/>
                        <BookmarkIconEmpty v-else alt="favorite-icon"/>
                    </div>
                    <div @click="addToCompareDeck"><CompareIcon alt="compare-icon"/></div>
                </div>
            </div>
            <div class="product-card__image-content">
                <Link :href="route('productDetail.show', [productCardDetails.seo_name])" :data="pdpLinkParams">
                    <Media v-if="firstTwoImages[0]?.image" alt="product__image" mediaClasses="product-card__image-one product-image"
                        :media="firstTwoImages[0].image" :id="`${slugifiedTitle}-product-image-nohover`" defaultMediaType=“image” />
                    <Media v-if="firstTwoImages[1]?.image" alt="product__image" mediaClasses="product-card__image-two product-image"
                        :media="firstTwoImages[1].image" :id="`${slugifiedTitle}-product-image-hover`" defaultMediaType=“image” />
                </Link>
                <div class="product-card__image-actions mobile-hidden-flex">
                    <div class="product-card__image-mark badge" v-if="productCardDetails.bestSeller || productCardDetails.badge" :id="`${slugifiedTitle}-badge`">
                        {{ productCardDetails.badge ?? 'BEST SELLER' }}
                    </div>
                    <div class="product-card__image-favorite">
                        <div @click="changeListStatus">
                            <BookmarkIcon v-if="favoriteFillStyle" alt="favorite-icon"/>
                            <BookmarkIconEmpty v-else alt="favorite-icon"/>
                        </div>
                        <div @click="addToCompareDeck"><CompareIcon alt="compare-icon"/></div>
                    </div>
                </div>
                <div v-if="showQuickViewButton" class="product-card__quickview"  role="button" tabindex="0" @click.prevent="toggleBuystackFlyout(productCardDetails.seo_name, selectedColor)">
                    <div class="product-card__quickview"  role="button" tabindex="0">
                        <a href="" class="product-card__quickview-button">
                            <div class="product-card__quickview-icon">
                                <CartIcon alt="cart-icon" role="button" :aria-label="`Quick View ${productCardDetails.title}`"/>
                            </div>
                            <div class="product-card__quickview-text">Quick Shop</div>
                        </a>
                    </div>
                </div>
            </div>
            <div class="product-card__swatches-container">
                <div @click="prevColorPage" v-if="currentColorPage > 0" class="product-card__swatches-more" style="gap: 0; width: 1.7rem; cursor: pointer;">
                    <SwatchesMoreIcon alt="swatch-color-arrow" class="icon-flipped" />
                </div>
                <div class="product-card__swatches hide-subsequent-rows">
                    <div class="product-card__swatch" v-for="(color, index) in paginatedColors" :key="index" @click="selectedColor = color.color"
                        :aria-label="`select ${color.color} swatch color`">
                        <div :class="`product-card__swatches-color ${index == paginatedColors.findIndex(c=>c.color == selectedColor) ? 'active' : ''}`">
                            <img 
                                :alt="`select ${color.color} swatch color`"
                                :title="color.color" 
                                loading="lazy"
                                class="swatch-image" 
                                :src="optimize(color.swatch)" 
                            />
                        </div>
                    </div>
                </div>
                <div @click="nextColorPage" v-if="productCardDetails.numberOfColors > itemsPerPage && currentColorPage < totalColorPages - 1" class="product-card__swatches-more" 
                    :style="currentColorPage == 0 ? `gap: ${productCardDetails.numberOfColors - itemsPerPage > 9 ? '1' : '5'}px; cursor: pointer;` : 'gap: 0; width: 1.7rem; cursor: pointer;'">
                    <div class="product-card__swatches-colors-count" v-if="currentColorPage == 0">
                        +{{ productCardDetails.numberOfColors - itemsPerPage }}
                    </div>
                    <SwatchesMoreIcon alt="swatch-color-arrow" />
                </div>
            </div>
            <div class="product-card__description">
                <Link :href="route('productDetail.show', [productCardDetails.seo_name])" :data="pdpLinkParams" style="text-decoration: none">
                    <div class="product-card__title title-s">{{ formatTitle(productCardDetails.title) }}</div>
                </Link>
                <div class="product-card__price paragraph-details" :id="`${slugifiedTitle}-price`"><span
                        class="product-card__price_from paragraph-caption">from</span>
                        <span :id="`${slugifiedTitle}-discount-price`" class="text-rothcoRed" v-if="productCardDetails.discountedPrice">
                             ${{ productCardDetails.discountedPrice }}
                        </span>
                        <span :class="productCardDetails.discountedPrice ? 'product-card__price_from' : ''" 
                            :style="productCardDetails.discountedPrice ? `text-decoration-line: line-through; font-weight: normal;` : ``">
                             ${{ productCardDetails.price }}
                        </span>
                    </div>
                <div class="product-card__ratings">
                    <div class="product-card__durability paragraph-caption" v-if="productCardDetails.tag" :id="`${slugifiedTitle}-tag`">
                        {{ productCardDetails.tag }}
                    </div>
                    <div class="star-content" v-if="productCardDetails.reviewCount > 0 && productCardDetails.rating >= 4">
                        <div class="product-card__stars">
                            <StarRating :rating="productCardDetails.rating" />
                        </div>
                        <p class="paragraph-caption product-card__stars_count">({{ productCardDetails.reviewCount ?? 0 }})</p>
                    </div>
                </div>
                <div class="product-card__discount paragraph-caption" v-if="productCardDetails.promotions">{{ productCardDetails.promotions }}</div>
            </div>
        </div>
        <!-- Product Card DTC Item END -->

        <!-- Product Card B2B Item START -->
        <div class="product-card" v-else>
            <div class="product-card__image-actions desktop-hidden-flex">
                <div class="product-card__image-mark badge" v-if="productCardDetails.bestSeller || productCardDetails.badge" :id="`${slugifiedTitle}-badge`">
                    {{ productCardDetails.badge ?? 'BEST SELLER' }}
                </div>
                <div class="product-card__image-favorite">
                    <div @click="changeListStatus">
                        <BookmarkIcon v-if="favoriteFillStyle" alt="favorite-icon"/>
                        <BookmarkIconEmpty v-else alt="favorite-icon"/>
                    </div>
                    <div @click="addToCompareDeck"><CompareIcon alt="compare-icon"/></div>
                </div>
            </div>
            <div class="product-card__image-content">
                <Link :href="route('productDetail.show', [productCardDetails.seo_name])" :data="pdpLinkParams">
                    <Media v-if="firstTwoImages[0]?.image" alt="product__image" mediaClasses="product-card__image-one product-image"
                        :media="firstTwoImages[0].image" :id="`${slugifiedTitle}-product-image-nohover`" defaultMediaType=“image” />
                    <Media v-if="firstTwoImages[1]?.image" alt="product__image" mediaClasses="product-card__image-two product-image"
                        :media="firstTwoImages[1].image" :id="`${slugifiedTitle}-product-image-nohover`" defaultMediaType=“image” />
                </Link>
                <div class="product-card__image-actions mobile-hidden-flex">
                    <div class="product-card__image-mark badge" v-if="productCardDetails.bestSeller || productCardDetails.badge" :id="`${slugifiedTitle}-badge`">
                        {{ productCardDetails.badge ?? 'BEST SELLER' }}
                    </div>
                    <div class="product-card__image-favorite">
                        <div @click="changeListStatus">
                            <BookmarkIcon v-if="favoriteFillStyle" alt="favorite-icon"/>
                            <BookmarkIconEmpty v-else alt="favorite-icon"/>
                        </div>
                        <div @click="addToCompareDeck"><CompareIcon alt="compare-icon"/></div>
                    </div>
                </div>
                <div v-if="showQuickViewButton" class="product-card__quickview"  role="button" tabindex="0" @click.prevent="toggleBuystackFlyout(productCardDetails.seo_name, selectedColor)">
                    <div class="product-card__quickview"  role="button" tabindex="0">
                        <a href="" class="product-card__quickview-button">
                            <div class="product-card__quickview-icon">
                                <CartIcon alt="cart-icon" role="button" :aria-label="`Quick View ${productCardDetails.title}`" />
                            </div>
                            <div class="product-card__quickview-text">Quick Shop</div>
                        </a>
                    </div>
                </div>
            </div>
            <div class="product-card__swatches-container">
                <div @click="prevColorPage" v-if="currentColorPage > 0" class="product-card__swatches-more" style="gap: 0; width: 1.7rem; cursor: pointer;">
                    <SwatchesMoreIcon alt="swatch-color-arrow" class="icon-flipped" />
                </div>
                <div class="product-card__swatches hide-subsequent-rows">
                    <div class="product-card__swatch" v-for="(color, index) in paginatedColors" :key="index" @click="selectedColor = color.color"
                        :aria-label="`select ${color.color} swatch color`">
                        <div :class="`product-card__swatches-color ${index == paginatedColors.findIndex(c=>c.color == selectedColor) ? 'active' : ''}`">
                            <img 
                                :alt="`select ${color.color} swatch color`"
                                :title="color.color" 
                                loading="lazy"
                                class="swatch-image" 
                                :src="optimize(color.swatch)" 
                            />
                        </div>
                    </div>
                </div>
                <div @click="nextColorPage" v-if="productCardDetails.numberOfColors > itemsPerPage && currentColorPage < totalColorPages - 1" class="product-card__swatches-more" 
                    :style="currentColorPage == 0 ? `gap: ${productCardDetails.numberOfColors - itemsPerPage > 9 ? '1' : '5'}px; cursor: pointer;` : 'gap: 0; width: 1.7rem; cursor: pointer;'">
                    <div class="product-card__swatches-colors-count" v-if="currentColorPage == 0">
                        +{{ productCardDetails.numberOfColors - itemsPerPage }}
                    </div>
                    <SwatchesMoreIcon alt="swatch-color-arrow"/>
                </div>
            </div>
            <div class="product-card__description">
                <Link :href="route('productDetail.show', [productCardDetails.seo_name])" :data="pdpLinkParams" style="text-decoration: none">
                    <div class="product-card__title title-s">{{ formatTitle(productCardDetails.title) }}</div>
                </Link>
                <p class="product-card__price-hidden paragraph-details" :id="`${slugifiedTitle}-d2c-price`">View Item to See Your Pricing</p>
                <div class="product-card__ratings">
                    <div class="product-card__durability paragraph-caption" v-if="productCardDetails.tag" :id="`${slugifiedTitle}-tag`">
                        {{ productCardDetails.tag }}
                    </div>
                    <div class="star-content" v-if="productCardDetails.reviewCount > 0 && productCardDetails.rating >= 4">
                        <div class="product-card__stars">
                            <StarRating :rating="productCardDetails.rating" />
                        </div>
                        <p class="paragraph-caption product-card__stars_count">({{ productCardDetails.reviewCount ?? 0 }})</p>
                    </div>
                </div>
                <div class="product-card__discount paragraph-caption" v-if="productCardDetails.promotions">{{ productCardDetails.promotions }}
                </div>
            </div>
        </div>
        <!-- Product Card B2B Item END -->

</template>
<script lang="ts" setup>
    import { computed, ref, reactive, toRefs, inject } from "vue";
    import { Link } from "@inertiajs/vue3";
    import type { PropType } from "vue";
    import Media from "./Media.vue";
    import { useSettingsStore } from "@/store/settings";
    import { storeToRefs } from "pinia";
    import { createUseFavoritesStore } from "@/store/favorites";
    import { useCompareDeckStore } from "@/store/compareDeck.ts";
    import { useFetch } from "@/helpers/composables/useFetch";
    import { useProductDetails } from "@/helpers/composables/useProductDetails";
    import CompareIcon from "@icons/iconamoon_compare-light.svg"
    import NProgress from "nprogress";
    import { watchDeep } from "@vueuse/core";
    import { slugify } from "@/helpers/composables/slugify";
    import StarRating from "@/components/StarRating.vue";
    import useImageOptimization from "@/helpers/composables/useImageOptimization";
    import he from "he";
    import FavoriteIcon from "@icons/favorite-icon-product-card.svg";
    import FavoriteIconEmpty from "@icons/favorite-icon-product-card-empty.svg";
    import BookmarkIcon from "@icons/bookmarked.svg";
    import BookmarkIconEmpty from "@icons/bookmark-default.svg";
    import CartIcon from "@icons/product-card-cart.svg";
    import SwatchesMoreIcon from "@icons/swatches-arrow-more.svg";
    import { comingSoonImages } from "@/helpers/composables/comingSoonImages"

    let settings = useSettingsStore();
    let { toggleFlyout, toggleBuystackFlyout, setNotificationMessage } = settings;
    let { user, isLoggedIn } = storeToRefs(settings);
    let isB2B = computed(() => user.value.is_dealer);

    export interface productImage {
        image: string;
        hoverImage?: string;
        customColorSwatchButton?: string;
        color?: string;
    }

    export interface ProductCardDetails {
        productImages: Array<productImage>;
        title: string;
        url: string;
        price?: number;
        discountedPrice?: number;
        rating?: number;
        reviewCount?: number;
        tag?: string;
        badge?: string;
        promotions?: string;
        isB2B?: boolean;
        isInList?: boolean;
        seo_name: string;
        bestSeller?: boolean;
        variants: Array<Object>;
        numberOfColors: number;
        isFavorite?: boolean;
        product_id: string;
        favorite_id?: string;
    }

    let props = defineProps({
        type: {
            type: String,
            default: 'product'
        },
        merchandising: {
            type: Object,
            default(){
                return {}
            }
        },
        activeColors: {
            type: Array as PropType<Array<string>>,
            default: () => []
        },
        productCardDetails: {
            type: Object as PropType<ProductCardDetails>,
            required: true,
            default(){
                return {
                    productImages: [],
                    title: "",
                    url: "",
                    price: 0,
                    discountedPrice: 0,
                    rating: 0,
                    reviewCount: 0,
                    tag: "",
                    badge: "",
                    promotions: "",
                    isB2B: false,
                    isInList: false,
                    seo_name: "",
                    bestSeller: false,
                    variants: [],
                    numberOfColors: 0,
                    isFavorite: false,
                    product_id: "",
                    favorite_id: ""
                }
            }
        },
        allowQuickView: {
            type: Boolean,
            default: false
        }
    });
    let route = inject("route");
    let { productCardDetails } = toRefs(props);

    let {addFavorite, deleteFavorite} = createUseFavoritesStore(`favorite-${productCardDetails.value.product_id}`, {
        item_index: productCardDetails.value.product_id, 
        user_id: user.value.user_id,
    })();

    let favoriteFillStyle = computed(()=>{
        return productCardDetails.value.isFavorite;
    });
    let slugifiedTitle = computed(() =>
        slugify(productCardDetails.value.title)
    );

    const handleAccountLogin = () => {
        toggleFlyout({
            type: 'info',
            headline: 'Adding to Favorites? ',
            message: 'Please log in to save your favorite items.',
        });
    };

    let { addProductToDeck, openCompareDeck } = useCompareDeckStore();

    const addToCompareDeck = ()=>{
        useFetch(route('productDetail.quickView', [props.productCardDetails.seo_name]), {
            beforeFetch(ctx){
                NProgress.start();
            },
            afterFetch(ctx) {
                if (NProgress.isStarted()) {
                    NProgress.done();
                }

                const pricing = ref(Object.values(ctx.data.prices));
                const pricingComputed = computed(()=>{
                    return pricing.value;
                })

                const productResponse = {
                    product_seo_name: props.productCardDetails.seo_name,
                    color: selectedColor.value,
                    product: ctx.data.product,
                    prices: pricingComputed.value ?? []
                }

                const productDetails = useProductDetails({
                    product: productResponse.product,
                    prices: pricingComputed,
                    route: route,
                })
                
                if(selectedColor.value){
                    let specGroup = productDetails.buyStack.value['Color'];
                    let specValue = specGroup.values.find(val=>(val.spec_value == selectedColor.value));
                    if(specValue){
                        productDetails.addVariationValue({...specValue, specGroup});
                    }
                }
                
                try {
                    addProductToDeck({
                        item_name: productResponse.product.item_name,
                        primary_image: productDetails.primaryImage.value ? `${import.meta.env.VITE_APP_URL}/upload/product/product/${productDetails.primaryImage.value}`
                            : comingSoonImages().small,
                        selectedVariant: {...productDetails.closestVariant.value, item: {seo_name: props.productCardDetails.seo_name}},
                        pricing: productDetails.productPricing.value,
                        item_specifications: [
                            ...productResponse.product.item_specifications,
                            ...productDetails.variationSpecs.value
                        ],
                        swatch_images: productResponse.product.swatch_images ?? {},
                    });

                    openCompareDeck()
                }catch(e){
                    setNotificationMessage({
                        message: "There was an issue trying to compare this item, please try again.",
                        type: 'error'
                    });
                }
            },
            onFetchError(ctx){
                if (NProgress.isStarted()) {
                    NProgress.done();
                }
                
                setNotificationMessage({
                    message: "There was an issue trying to compare this item, please try again.",
                    type: 'error'
                });
            }
        }).get().json()
    }

    function changeListStatus() {
        if(!isLoggedIn.value) {
            handleAccountLogin();
            return;
        }
        if(!favoriteFillStyle.value){
            productCardDetails.value.isFavorite = favoriteFillStyle.value;
            addFavorite();
        }else{
            productCardDetails.value.isFavorite = favoriteFillStyle.value;
            deleteFavorite();
        }
    }

    let uniqueColors = computed(()=>{
        const seen = new Set();
        if(productCardDetails.value.variants == null){
            return [];
        }
        return productCardDetails.value.variants?.filter(item => {
            const value = item['color'];
            if(value == null){
                return false;
            }
            if (seen.has(value)) {
                return false;
            } else {
                seen.add(value);
                return true;
            }
        });
    });
    let itemsMappedByColor = computed(()=>{
        return productCardDetails.value.variants?.reduce((acc, item) => {
            if(!acc.has(item.color)){
                let arr = [];
                arr.push({
                    color: item.color,
                    swatch: item.swatch,
                    days_after_activation: item.days_after_activation,
                    '12m_sales_priority': item['12m_sales_priority'] ?? 0
                });
                acc.set(item.color, arr);
            }else{
                acc.get(item.color).push({
                    color: item.color,
                    swatch: item.swatch,
                    days_after_activation: item.days_after_activation,
                    '12m_sales_priority': item['12m_sales_priority'] ?? 0
                });
            }
            return acc;
        }, new Map());
    })
    let uniqueColorsWeighted = computed(()=>{
        // find colors that have only new items(less than 30 days after activation)
        let newColors = [];
        let oldColors = [];
        itemsMappedByColor.value.forEach((value, key) => {
            let oldItem = value.find(item=>item.days_after_activation > 30);
            if(!oldItem){
                newColors.push(key);
            }else{
                let oldItems = value.filter(item=>item.days_after_activation > 30);
                oldColors.push({
                    color: key,
                    '12m_sales_priority': oldItems.reduce((acc, item)=>acc + (item['12m_sales_priority'] ?? 0), 0)
                });
            }
        });

        if(newColors.length > 0){
            return newColors;
        }else{
            // return the top 3 colors with the highest 12m_sales_priority
            return oldColors.sort((a, b) => {
                return b['12m_sales_priority'] - a['12m_sales_priority'];
            }).map(item => item.color).slice(0, oldColors.length < 3 ? 1 : 3);
        }
    })

    let selectedColorIsNew = computed(()=>{
        let itemsOfSelectedColor = itemsMappedByColor.value.get(selectedColor.value);
        return itemsOfSelectedColor.every(item=>item.days_after_activation < 30);
    })
    let currentColorPage = ref(0);
    const itemsPerPage = 6;

    let totalColorPages = computed(()=>{
        return Math.ceil(productCardDetails.value.numberOfColors / itemsPerPage);
    });

    let paginatedColors = computed(()=>{
        const start = currentColorPage.value * itemsPerPage;
        const end = start + itemsPerPage;
        return uniqueColors.value.slice(start, end);
    });

    function nextColorPage(){
        if (currentColorPage.value < totalColorPages.value - 1) {
            currentColorPage.value++;
        }
    }

    function prevColorPage(){
        if (currentColorPage.value > 0) {
            currentColorPage.value--;
        }
    }

    let selectedColor = ref("");

    let firstTwoImages = computed(() => {
        let selectedImages = productCardDetails.value.productImages
        if(productCardDetails.value.numberOfColors > 0){
            let selectedVariant = productCardDetails.value.variants.find(variant=>variant.color == selectedColor.value);
            selectedImages = [
                {image: selectedVariant?.thumbnail_url},
            ];
            if(selectedVariant?.hover_image){
                selectedImages.push({image: selectedVariant.hover_image});
            }
        }
        //if there is only one image, push it twice
        if (selectedImages.length === 1) {
            return [
                selectedImages[0],
                selectedImages[0]
            ];
        }
        return selectedImages.slice(0, 2);
    });
    let pdpLinkParams = computed(()=>{
        if(selectedColor.value != null){
            return {
                color: selectedColor.value
            }
        }
        return {}
    })

    const showQuickViewButton = computed(()=>{
        return props.allowQuickView
    })

    let randomInitialColor = computed(()=>{
        if(props.activeColors.length > 0){
            // if there is an active color that exists in the uniqueColors, return it
            let activeColor = props.activeColors.find(color => uniqueColors.value.find(c => c.color == color));
            if(activeColor){
                return activeColor;
            }
        }
        return uniqueColorsWeighted.value[Math.floor(Math.random() * uniqueColorsWeighted.value.length)];
    })

    let findPageForColor = (color: string) => {
        let page = Math.floor(uniqueColors.value.findIndex(c => c.color == color) / itemsPerPage);
        if(page < 0){
            return 0;
        }
        return page;
    }
    watchDeep(() =>randomInitialColor, (newValue) => {
        if(newValue != null){
            selectedColor.value = newValue.value;
            currentColorPage.value = findPageForColor(newValue.value);
        }
    }, {
        immediate: true, once: true
    });


    watchDeep(()=>props.activeColors, newVal => {
        if(newVal.length > 0){
            selectedColor.value = props.activeColors.find(color =>  uniqueColors.value.find(c => c.color == color)) ?? randomInitialColor.value;
            currentColorPage.value = findPageForColor(selectedColor.value);
        }else{
            selectedColor.value = randomInitialColor.value;
            currentColorPage.value = findPageForColor(selectedColor.value);
        }
    }, { immediate: false });

    function formatTitle(title: string) {
        return he.decode(title);
    }
    

    let { optimize } = useImageOptimization();
</script>
<style lang="scss" scoped>
.icon-flipped {
    transform: scaleX(-1);
    -moz-transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
    -ms-transform: scaleX(-1);
}
</style>
